import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["state"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEvent, useRefId } from 'ariakit-utils/hooks';
import { createHook, createComponent, createElement } from 'ariakit-utils/system';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useButton } from '../button/button.js';
var children = /*#__PURE__*/jsxs("svg", {
  "aria-hidden": "true",
  display: "block",
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1pt",
  width: "1em",
  height: "1em",
  pointerEvents: "none",
  children: [/*#__PURE__*/jsx("line", {
    x1: "5",
    y1: "5",
    x2: "11",
    y2: "11"
  }), /*#__PURE__*/jsx("line", {
    x1: "5",
    y1: "11",
    x2: "11",
    y2: "5"
  })]
});
/**
 * A component hook that returns props that can be passed to `Role` or any other
 * Ariakit component to render a combobox cancel button that clears the combobox
 * input when clicked.
 * @see https://ariakit.org/components/combobox
 * @example
 * ```jsx
 * const state = useComboboxState();
 * const props = useComboboxCancel({ state });
 * <Combobox state={state} />
 * <Role {...props} />
 * ```
 */

var useComboboxCancel = createHook(function (_ref) {
  var state = _ref.state,
      props = _objectWithoutProperties(_ref, _excluded);

  var onClickProp = props.onClick;
  var onClick = useEvent(function (event) {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    state.setValue(""); // Move focus to the combobox input.

    state.move(null);
  });
  var comboboxId = useRefId(state.baseRef);
  props = _objectSpread(_objectSpread({
    children: children,
    "aria-label": "Clear input",
    // This aria-controls will ensure the combobox popup remains visible when
    // this element gets focused. This logic is done in the ComboboxPopover
    // component.
    "aria-controls": comboboxId
  }, props), {}, {
    onClick: onClick
  });
  props = useButton(props);
  return props;
});
/**
 * A component that renders a combobox cancel button that clears the combobox
 * input when clicked.
 * @see https://ariakit.org/components/combobox
 * @example
 * ```jsx
 * const combobox = useComboboxState();
 * <Combobox state={combobox} />
 * <ComboboxCancel state={combobox} />
 * <ComboboxPopover state={combobox}>
 *   <ComboboxItem value="Item 1" />
 *   <ComboboxItem value="Item 2" />
 *   <ComboboxItem value="Item 3" />
 * </ComboboxPopover>
 * ```
 */

var ComboboxCancel = createComponent(function (props) {
  var htmlProps = useComboboxCancel(props);
  return createElement("button", htmlProps);
});
export { ComboboxCancel, useComboboxCancel };